var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalanderCheckRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83008 2.00003V4.85003M11.5301 2.00003V4.85003M15.0926 10.55V4.85003C15.0926 4.4721 14.9424 4.10964 14.6752 3.8424C14.408 3.57516 14.0455 3.42503 13.6676 3.42503H3.69258C3.31464 3.42503 2.95219 3.57516 2.68495 3.8424C2.41771 4.10964 2.26758 4.4721 2.26758 4.85003V14.825C2.26758 15.203 2.41771 15.5654 2.68495 15.8327C2.95219 16.0999 3.31464 16.25 3.69258 16.25H9.39258M2.26758 7.70003H15.0926M11.5301 14.825L12.9551 16.25L15.8051 13.4",
    stroke: "#F3821E",
    strokeWidth: 1.425,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderCheckRed);
export default __webpack_public_path__ + "static/media/calander-check-red.5e5a5571e3cc4de528d9f84a36d63b59.svg";
export { ForwardRef as ReactComponent };